<template>
  <div class="searchOption">
      <div class="tBtn"
            :class="{ active: chartIndex===item.label }"
            v-for="item in timeOption"
            :key="item.label"
            @click="queryChart(item)"
      >{{ item.label }}</div>
  </div>
</template>

<script>
import DayJS from "dayjs";

export default {
  data() {
    const curDate = DayJS().format("YYYY-MM-DD HH:mm:ss");
    const curMonth = DayJS().format("YYYY-MM");
    return {
      chartIndex: '最近半年',
      timeOption: [
        {
          value: [
            DayJS(curMonth).subtract(5, "month").format("YYYY-MM-DD HH:mm:ss"),
            curDate,
          ],
          label: '最近半年',
        },
        {
          value: [
            DayJS(curMonth).subtract(2, "month").format("YYYY-MM-DD HH:mm:ss"),
            curDate,
          ],
          label: '最近三个月',
        },
        {
          value: [
            DayJS(curMonth).subtract(11, "month").format("YYYY-MM-DD HH:mm:ss"),
            curDate,
          ],
          label: '最近一年',
        },
      ],
    }
  },
  mounted() {
    this.$emit('queryValue',this.timeOption[0].value)
  },
  methods: {
    queryChart(item) {
      if(this.chartIndex != item.label) {
        this.chartIndex = item.label;
        this.$emit('queryValue',item.value)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .searchOption {
    margin-left: 4%;
    font-size: 12px;
    display: flex;
    min-width: 230px;
    height: 33px;
    line-height: 33px;
  .tBtn {
    padding: 0 10px;
    border-radius: 9px;
    cursor: pointer;
    margin-right: 5px;
    border: 1px solid #9ca6b8;
    color:  #9ca6b8;
    transition: all .2s;
    &:hover {
      border: 1px solid #006eff;
      color: #006eff;
    }
  }

  .active {
    border: 1px solid #006eff;
    color: #006eff;
  }
}
</style>
